document.addEventListener("DOMContentLoaded", function(event) {
  var state = {
    hide: {
      links: 'col-xs-12 tle-footer-train-links tle-footer-toggled',
      header: 'tle-footer-accordion-header',
      carat: 'tle-footer-accordion-carat'
    },
    show: {
      links: 'col-xs-12 tle-footer-train-links',
      header: 'tle-footer-accordion-header tle-footer-toggled',
      carat: 'tle-footer-accordion-carat tle-footer-flipped'
    }
  };
  var accordion = document.getElementById('tle-footer-accordion');

  accordion.onclick = function(event) {
    event.preventDefault();

    var trainLinks = document.getElementsByClassName('tle-footer-train-links')[0];
    var trainLinksHeader = document.getElementsByClassName('tle-footer-accordion-header')[0];
    var trainLinksCarat = document.getElementsByClassName('tle-footer-accordion-carat')[0];

    var classes = trainLinks.className.indexOf('tle-footer-toggled') !== -1 ? state.show : state.hide;

    trainLinks.className = classes.links;
    trainLinksHeader.className = classes.header;
    trainLinksCarat.className = classes.carat;
  }
});
